import { inject, Injectable } from '@angular/core';
import { Column, Upright } from '../asset/asset.dto';
import { ASSETS_COLLECTION, COLUMNS_COLLECTION, firstCollectionData, ID_FIELD_OPTIONS, WW_WAREHOUSES_COLLECTION } from '@damofire/data-commons';
import { UprightService } from './upright.service';
import { firstValueFrom } from 'rxjs';
import { collection, doc, docData, Firestore, query, where } from '@angular/fire/firestore';

@Injectable()
export class FirebaseUprightService implements UprightService {
  private readonly firestore = inject(Firestore);

  async get(division: string, id: string): Promise<Upright> {
    return firstValueFrom(docData(doc(this.firestore, `${WW_WAREHOUSES_COLLECTION}/${division}/${ASSETS_COLLECTION}/${id}`), ID_FIELD_OPTIONS));
  }

  list(division: string, systemId: string): Promise<Upright[]> {
    const queryFn = query(collection(this.firestore, `${WW_WAREHOUSES_COLLECTION}/${division}/${ASSETS_COLLECTION}`), where('systemId', '==', systemId));
    return firstCollectionData<Upright>(queryFn);
  }

  async listColumns(division: string, assetIds: string[], rowIndex?: number): Promise<Column[]> {
    const columns: Column[] = [];

    while (assetIds.length) {
      const assetIdsChunk = assetIds.splice(0, 10);
      const queryFn = query(collection(this.firestore, `${WW_WAREHOUSES_COLLECTION}/${division}/${COLUMNS_COLLECTION}`), where('assetId', 'in', assetIdsChunk));
      const all = await firstCollectionData<Upright>(queryFn);
      all.filter((u: Column) => !rowIndex || u.rowIndex === rowIndex).forEach((c) => columns.push(c));
    }

    return columns;
  }
}
